import _ from "lodash";
import { fetchApi } from "../../utils";

export const createCareerApplies = async (values) => {
  const data = {
    position_id: _.get(values, 'position'),
    expected_salary: _.get(values, 'expected_salary'),
    firstname: _.get(values, 'firstname'),
    lastname: _.get(values, 'lastname'),
    age: _.get(values, 'age'),
    gender: _.get(values, 'gender'),
    address: _.get(values, 'address'),
    provice: _.get(values, 'provice'),
    zipcode: _.get(values, 'zipcode'),
    phone: _.get(values, 'phone'),
    pernal_information: _.get(values, 'pernal_information'),
    pdf_id: _.get(values, 'pdf_id'),
    video_id: _.get(values, 'video_id'),
  }
  const result = await fetchApi('career_applies', 'POST', JSON.stringify(data));
  return result;
}


// WEBPACK FOOTER //
// ./src/services/page/careerapplies.js